/**
 * Convert a date format from pt-BR (dd/mm/aaaa) to en-US (mm/dd/aaaa)
 * @param  {string} A date in pt-BR format to be converted
 * @return {string} The correspondent date in en-US format
 */

export default (date) => {
  const [day, month, year] = date.split('/')

  return [month, day, year].join('/')
}
